module.exports = __webpack_public_path__ + "media/video_banner.b132bc52.mp4";